class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cartTotal');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    fetch(`${window.theme.routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-drawer');
        this.innerHTML = sourceQty.innerHTML;
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      })
      .catch((e) => {
        console.error(e);
      });
      
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    this.classList.add('animate');
    setTimeout(() => {
      this.classList.add('active');
    }, 250);

    fetch('/cart.js')
      .then((response) => response.json())
      .then(data => {
      
        const totalPrice = (data.total_price / 100).toFixed(2);

        const newItemObj = {
          'event': "view_cart",
          'ecommerce': {
            'currency': 'EUR',
            'drawer_cart': true,
            'value': totalPrice,
            'items': []
          }
        };
        
        data.items.forEach((item, index) => {
          
          const cartItems = document.querySelector('table.cart-items');

          let priceRegular = "";
          const priceEnd = parseFloat(cartItems.querySelectorAll('.product-price-new')[index].getAttribute('data-product-price'));
          if(cartItems.querySelectorAll('.product-price__sale')[index] != null) {
            priceRegular = parseFloat(cartItems.querySelectorAll('.product-price__sale')[index].getAttribute('data-compare-price'));
        
          }
          const discount = priceRegular != "" ? priceRegular - priceEnd : 0;

          let color = "";
          let size = "";

          item.options_with_values.forEach((key) => {
            if(key.name == "color" || key.name == "Color") {
              color = key.value;
            } else if(key.name == 'talla' || key.name == "Talla") {
              size = key.value;
            }
          });
          
    
          const newObj = {
            'item_id': item.id.toString(),
            'item_name': item.title,
            'currency': 'EUR',
            'item_category': item.product_type,
            'item_variant_id': item.variant_id.toString(),
            'price': (item.original_line_price / 100).toFixed(2),
            'price_new': (item.original_line_price / 100).toFixed(2),
            'item_brand': item.vendor,
            'content_group': "ecommerce",
            'sku': item.sku,
            'quantity': item.quantity,
            'index': index + 1,
            'item_color': color,
            'item_variant': size,
            'discount': (discount / 100).toFixed(2)
          }
      
          newItemObj.ecommerce.items.push(newObj);
    
        })
        dataLayer.push({ ecommerce: null });
        window.dataLayer.push(newItemObj)
        // Shopify.analytics.publish('view_cart', newItemObj);
      })

    document.body.classList.add('overflow-hidden');
    

    if (triggeredBy == 'openCookie') {
      this.setOpenCookie();
    }
  }

  close() {
    this.classList.remove('active');
    setTimeout(() => {
      this.classList.remove('animate');
    }, 750);
    document.body.classList.remove('overflow-hidden');
  }

  setOpenCookie() {
    function setSessionCookie(name, value) {
      sessionStorage.setItem(name, encodeURIComponent(value));
    }

    const drawerCartCookieName = "drawer_cart_opened";
  
    setSessionCookie(drawerCartCookieName, 'true');
  }
  

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


function addQuantityCart(item_id, item_title, item_type, item_color, item_size, item_price, item_vendor) {

  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "add_to_cart",
    ecommerce: {
      items: [{
        drawer: true,
        item_name: item_title,
        item_id: item_id,
        item_color: item_color,
        item_variant: item_size,
        item_category: item_type,
        price: item_price,
        item_brand: item_vendor,
        index: 1,
        quantity: 1
      }]
    }
  })

}

function removeQuantityCart(item_id, item_title, item_type, item_color, item_size, item_price, item_vendor, item_quantity) {
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "remove_from_cart",
    ecommerce: {
      items: [{
        drawer: true,
        item_name: item_title,
        item_id: item_id,
        item_color: item_color,
        item_variant: item_size,
        item_category: item_type,
        price: item_price,
        item_brand: item_vendor,
        index: 1,
        quantity: item_quantity ? parseInt(item_quantity) : 1
      }]
    }
  })

}